import { Message } from 'element-ui';
import { withDialogOverlayZIndex } from '@/script/dialogZIndex.js';
const OFFSET = 200;
// 保存原始方法
const originalMessage = Message;

// 封装自定义 message，只改 offset
const customMessage = (options) => {
    if (typeof options === 'string') {
        options = {
            message: options,
        };
    }

    return originalMessage(withDialogOverlayZIndex({
        offset: OFFSET,  // 全局设置偏移量
        ...options,  // 保留原始行为，允许局部覆盖
    }));
};

// 修复 Message 的不同类型方法（如 success、error 等）
['success', 'warning', 'info', 'error'].forEach(type => {
    customMessage[type] = (options) => {
        if (typeof options === 'string') {
            options = {
                message: options,
            };
        }
        return originalMessage(withDialogOverlayZIndex({
            offset: OFFSET,
            type,
            ...options,
        }));
    };
});

export default customMessage;